export const MEMBERSHIP_QUERY = `
query MembershipQuery {
  membership(id: "", type: JWT_TOKEN) {
    accountToken
    demographics {
      firstName
      isTopCard
      product {
        productId
        isBasic
        productFamily
        cardArtCdnLink
      }
      homeCountryLocale
      displayAccountNumber
    }
    travelBenefits {
      name
      corporateCodes {
        code
      }
    }
    loyalty {
      pointsBalance
    }
  }
}
`;
